import { Box, Grid, useMediaQuery, useTheme } from "@mui/material";
import Breadcrumbs from "app/frontend/components/static/Breadcrumbs";
import React, { PropsWithChildren } from "react";

import EligibilityHeader from "app/frontend/components/eligibility/EligibilityHeader";
import ContentFooter from "app/frontend/components/static/ContentFooter";
import Header from "app/frontend/components/static/Header";
import PageFooter from "app/frontend/components/static/PageFooter";
import BottomQuickLinks from "app/frontend/components/static/incentives/BottomQuickLinks";
import ConsultAnAdvisor from "app/frontend/components/static/incentives/ConsultAnAdvisor";
import IncentivesCardGroup from "app/frontend/components/static/incentives/IncentivesCardGroup";
import { EProjectTypes } from "app/frontend/constants/enums";
import { ROUTES } from "app/frontend/constants/routes";
import { useParams } from "app/frontend/hooks/useParams";
import { useProjectParams } from "app/frontend/hooks/usePropsParams";

const EligibilityLayout: React.FC<PropsWithChildren & Record<string, any>> = ({ children, ...props }) => {
    const theme = useTheme();
    const isMobileDevice = useMediaQuery(theme.breakpoints.down("lg"));
    const { project_type }: { project_type: EProjectTypes } = useParams();
    const projectParams = useProjectParams();

    return (
        <main>
            <Header />
            <Breadcrumbs
                breadcrumbs={[
                    {
                        title: "Home",
                        href: ROUTES.Eligibility.ROOT,
                    },
                    {
                        title: "Eligibility Assessment",
                    },
                ]}
            />

            {isMobileDevice ? project_type ? null : <EligibilityHeader /> : <EligibilityHeader />}

            <Box sx={{ minWidth: "100%", px: 2 }} my={2} className="layout-box">
                {React.Children.map(children, (child) =>
                    React.isValidElement(child)
                        ? React.cloneElement(child, {
                              ...(child?.props ?? {}),
                              ...props,
                          })
                        : child,
                )}
            </Box>

            {!!projectParams.plugs?.length && (
                <>
                    <IncentivesCardGroup />

                    <Box sx={{ minWidth: "100%", px: 2 }} my={2} className="layout-box">
                        <Grid
                            container
                            spacing={{ xs: 2, md: "20px" }}
                            sx={{ my: { sm: "50px" }, mx: { sm: "100px" } }}
                        >
                            <BottomQuickLinks />
                            <Grid size={12}>
                                <Box>
                                    <ConsultAnAdvisor />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </>
            )}

            <ContentFooter />

            <PageFooter />
        </main>
    );
};

const Layout = (page: React.JSX.Element) => <EligibilityLayout {...page.props}>{page}</EligibilityLayout>;

export default Layout;
